import React, { Fragment, memo, useContext, useEffect, useState } from "react";
// Provider
import {
  AppContext,
  LOG_OUT_SUCCESS,
  SET_USER_HEALTH,
  SocketCommand,
  socketManager,
} from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";

// UI
import { ContainerNew, SubMenu, closeLayerFn, openLayerFn } from "../Layout";

// import _T_PRESCRIPTION from "../../resources/images/sub/prescription_img.jpg";
import _T_a from "../../resources/images/sub/contents_top_sub_bg4.jpg";

import _T_Q_menu1 from "../../resources/images/main/quick_icon_myp01.png";
import _T_Q_menu3 from "../../resources/images/main/quick_icon_myp03.png";
import _T_Q_menu4 from "../../resources/images/main/quick_icon_myp04.png";
import _T_USER_DEFAULT_MALE from "../../resources/images/user/photo_default_img.jpg";
import _T_USER_DEFAULT_FEMALE from "../../resources/images/user/photo_default_img2.jpg";
// 테스트
import { AlertLayer, ConfirmLayer } from "../../components/UI/Dialog";

import { PostApi1902 } from "../../modules/network/padoPost";
import { Health, HealthInput } from "../SelfManagement/SM.Layers";

import styled from "styled-components";
import { List } from "../../components";
import { NativeAction } from "../../modules/utils/HandleWs";
import { userHabit } from "../../modules/utils/UserHabit";
import { getCookie } from "../../modules/utils/cookie";
import { IC, ListIcon } from "../../resources/Assets";
import { loginLogInterface } from "../Membership/Login";
import useTitle from "../../modules/hooks/useTitle";

export default props => {
  const { userinfo, cfg, phonecfg, auth, dispatch } = useContext(AppContext);
  useTitle("마이페이지_메인");

  const [healthInfo, setHealthInfo] = useState();

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleAlert = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".alert-layer"));
  };

  const handleAlertCB = () => {
    closeLayerFn($(".alert-layer"));
  };

  const handleLogoutCancelCB = () => {
    closeLayerFn($(".confirm-layer"));
  };

  const handleLogoutConfirmCB = () => {
    dispatch({ type: LOG_OUT_SUCCESS });
    socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
      login: "out",
      userToken: "",
    });
    loginLogInterface(
      userinfo,
      phonecfg,
      cfg,
      "O",
      "M",
      getCookie("signUpChannel")
    );
    _O.Open("/membership/login");
    closeLayerFn($(".confirm-layer"));
  };
  // 다이얼로그 ]]

  const handleMyHealthInfo = () => {
    handleAlert("알림", "시나리오 오픈 예정입니다.");
    //openLayerFn($(".myhealth-list-layer"));
  };

  const request1902 = () => {
    PostApi1902(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.result) {
            dispatch({ type: SET_USER_HEALTH, data: res.result });
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    request1902();
  }, []);

  useEffect(() => {
    initView();
  });

  useEffect(() => {
    userHabit(phonecfg, "MP100");
    NativeAction(phonecfg, "statusColor", "#A5AEE4");
  }, [phonecfg.version]);

  return (
    <Fragment>
      <ContainerNew
        Title={"마이페이지"}
        leftMenu={SubMenu}
        // rightMenu={LogOutMenu}
        // gotoRightHandle={handleRightMenu}
        /*bottom={list.length === 0 ? <Bottom /> : null}*/ goToUrl={"/"}>
        <div className="contents sub myp">
          {/* <a href={void 0} onClick={(e) => handleLogoutConfirm('확인', '로그아웃 하겠습니까?')} className="btn-logout"></a>	 */}

          <SubTitle />

          <div className="sub-contents">
            <MyHealthInfo
              handleAlert={handleAlert}
              handleMyHealthInfo={handleMyHealthInfo}
            />

            <QuickMenu handleAlert={handleAlert} />

            <div className="pr-section" style={{ paddingTop: "40px" }}>
              <div className="main-section-title">기능목록</div>

              <div onClick={() => _O.OpenMenu("/card")}>
                <List
                  data={{
                    STATUS: "default",
                    CONTAINER_SHORT: true,
                    L_ICON: "",
                    TITLE: "결제수단 관리",
                    R_ICON: ListIcon.RECEIPT.R_ICON.CHEVRON_DEFAULT,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </ContainerNew>

      <AlertLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        handleAlertCB={handleAlertCB}
      />

      <ConfirmLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        handleCancelCB={handleLogoutCancelCB}
        handleConfirmCB={handleLogoutConfirmCB}
      />

      <HealthInput />
      {healthInfo && <Health healthInfo={healthInfo} />}
    </Fragment>
  );
};

const SubTitle = memo(props => {
  const { userinfo, auth } = useContext(AppContext);

  return (
    <div className="mypage-top-area">
      <img src={_T_a} alt="" />
      <div>
        <div className="inbox">
          <div className="photo">
            {auth && userinfo.sex === "1" && (
              <img src={_T_USER_DEFAULT_MALE} alt="" />
            )}
            {auth && userinfo.sex === "2" && (
              <img src={_T_USER_DEFAULT_FEMALE} alt="" />
            )}
          </div>
          <div className="member-info">
            <b>{auth ? userinfo.userName : ""}</b>
            <br />
            {auth ? userinfo.userPhone : ""}
            <div className="btn">
              <a href={void 0} onClick={e => _O.OpenMenu("/mp/myInfo/view")}>
                <i></i> 내 정보 보기
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

const MyHealthInfo = memo(({ handleAlert, handleMyHealthInfo }) => {
  const { auth, mypagecfg } = useContext(AppContext);

  return (
    <div className="pr-section">
      <div className="main-section-title">
        MY 건강정보
        <a
          href={void 0}
          className="btn-dots"
          onClick={e => _O.Open("/smOpen/1")}></a>
      </div>

      <div className="my-round-barlist"></div>
    </div>
  );
});

const QuickMenuList = [
  [
    {
      active: true,
      title: "병원정보 연동",
      imgSrc: IC.myPage.ICON_HSPT_CNNT,
      clickEvent: () => _O.OpenMenu("/cnntHspt/1/mp"),
    },
    {
      active: true,
      title: "내 쿠폰함",
      imgSrc: IC.myPage.ICON_CPN,
      clickEvent: () => _O.OpenMenu("/mp/couponList"),
    },
    {
      active: true,
      title: "가족 관리",
      imgSrc: _T_Q_menu1,
      clickEvent: () => _O.OpenMenu("/family"),
    },
  ],
  [
    {
      active: true,
      title: "공지사항",
      imgSrc: _T_Q_menu4,
      clickEvent: () => _O.OpenMenu("/mp/notice"),
    },
    {
      active: true,
      title: "악세사리 연동",
      imgSrc: IC.myPage.ICON_PHONE_CNNT,
      clickEvent: () => _O.OpenMenu("/mp/settings/accessory"),
    },
    {
      active: true,
      title: "설정",
      imgSrc: _T_Q_menu3,
      clickEvent: () => _O.OpenMenu("/mp/settings/0"),
    },
  ],
];

const QuickMenu = memo(({ handleAlert }) => {
  return (
    // <!-- 퀵메뉴 6개 -->
    // <div className="quick-menu-box inmyp">
    <QuickMenuDiv>
      {QuickMenuList.map((ul, i) => (
        <QuickMenuUl key={"menuDiv" + i}>
          {ul.map((menu, z) => (
            <li
              key={i + "menu" + z}
              style={{
                opacity: menu.active ? "1" : "0.5",
                height: "66px",
                width: "85.3px",
              }}>
              <a onClick={menu.clickEvent}>
                <div
                  style={{
                    display: "flex",
                    flexFlow: "column",
                    gap: "8px",
                    alignContent: "center",
                    flexWrap: "wrap",
                  }}>
                  <img
                    src={menu.imgSrc}
                    alt=""
                    style={{
                      width: "48px",
                      height: "42.8px",
                      margin: "0px auto",
                    }}
                  />
                  <p style={{ textAlign: "center" }}>{menu.title}</p>
                </div>
              </a>
            </li>
          ))}
        </QuickMenuUl>
      ))}
    </QuickMenuDiv>
  );
});

const initView = () => {
  ////건강정보입력 step1~3 레이어
  //레이어 열기
  $(".btn-openhealthlayer").click(function () {
    openLayerFn($(".health-input-layer"));
  });

  //다음
  $(".health-input-layer .btn-next").click(function () {
    var currentPaIndex = $(this).closest(".step-section").index();
    $(".health-input-layer .health-input-contain > div").hide();
    $(".health-input-layer .health-input-contain > div")
      .eq(currentPaIndex + 1)
      .show();
  });
  //이전
  $(".health-input-layer .btn-prev").click(function () {
    var currentPaIndex = $(this).closest(".step-section").index();
    $(".health-input-layer .health-input-contain > div").hide();
    $(".health-input-layer .health-input-contain > div")
      .eq(currentPaIndex - 1)
      .show();
  });
  //취소, 확인 (레이어 닫기);
  $(".health-input-layer .btn-cancel , .health-input-layer .btn-apply").click(
    function () {
      closeLayerFn($(".health-input-layer"));
      $(".health-input-layer .health-input-contain > div").hide();
      $(".health-input-layer .health-input-contain > div").eq(0).show();
    }
  );

  ////MY 건강정보 레이어
  //열기(건강정보이력 버튼)
  $(".btn-open-myhealth").click(function () {
    openLayerFn($(".myhealth-list-layer"));
  });
  //닫기(확인)
  $(".myhealth-list-layer .btn-close").click(function () {
    closeLayerFn($(".myhealth-list-layer"));
  });
  //수정 -- 닫고 "나의 건강정보 입력" 레이어 열기
  $(".btn-myinfmodify").click(function () {
    //현재 레이어 닫고
    closeLayerFn($(".myhealth-list-layer"));
    //"나의 건겅정보 입력" 레이어 열기
    openLayerFn($(".health-input-layer"));
  });
};

const QuickMenuDiv = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  gap: 16px;
  padding: 16px;
  border-radius: 6px;
  box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.15);
  background-color: #fff;
`;

const QuickMenuUl = styled.ul`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 0;
`;
